import { Box } from "@mui/material";
import GameGrid from "./GameGrid";

export default function GameBoard({
  cards,
  flippedIndices,
  matchedCards,
  onCardClick,
  cols,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <GameGrid
        cards={cards}
        flippedIndices={flippedIndices}
        matchedCards={matchedCards}
        onCardClick={onCardClick}
        cols={cols}
      />
    </Box>
  );
}
